/** 機能コード **/
export const FunctionCd = {
  COMPANY: "M01",
  PART: "M02",
  INPT_CHARAC: "M03",
  INSP_ATTACH: "M04",
  USER: "M05",
  MEAS_INST: "M06",
  DEFECT: "M07",
  DEFECT_GROUP: "M08",
  CHECK_LATEST_PARTS: "M09",
  INSP_FILT_UDPATE: "M10",
  XRF_GROUP: "M11",
  IMPORT_INSP_INDEX: "T01",
  SEARCH_INSP_INDEX: "T02",
  EDIT_INSP_INDEX: "T03",
  BOX_INFO: "T04",
  SEARCH_INSP_BOX: "T05",
  SEARCH_SA_HISTORY: "T06",
  REQUEST_SA: "T07",
  SEARCH_INSP_RESULT: "T09",
  INPUT_APP_INSP: "T10",
  INPUT_DIM_INSP: "T11",
  IMP_INSP_DATA_CSV: "T12",
  EXPORT_INSP_DATA_CSV: "T13",
  IMP_INSP_LOT: "T14",
  SEARCH_INSP_LOT: "T15",
  SEARCH_XRF_INSP_EXPR_DT: "T16",
  DEL_INSP_DATA: "T17",
  APPD_INSP_DATA: "T19",
  DEFECT_DETAIL_LIST: "T21",
  SEARCH_RETURN_RECORD: "T26",
  EDIT_RETURN_RECORD: "T27",
  ANALYZE_RECORD: "T28",
  SEARCH_MMMM_HISTORY: "T29",
  REQUEST_MMMM: "T30",
  INPUT_XRF_INSP: "T31",
  SEARCH_PARTS_INSP_INFO: "T32",
  DEFECT_PARETO_CHART: "R01",
  MEAS_VALUE_PLOT_CHART: "R02",
  DAILY_REPORT_DEFECT_RATE: "R03",
  DAILY_REPORT_INSP_LOAD: "R04",
  INSPECTION_RESULT_SUMMARY: "R05",
}

/** マニュアルファイル名 */
export const ManualFileName = {
  OQC: 'SPARQ_Manual_OQC.xlsx',
  IQC: 'SPARQ_Manual_IQC.xlsx',
  MASTER: 'SPARQ_Manual_Part_Maintenance.xlsx',
}

/** ロール */
export const Role = {
  INSPECTION_RESULT_CHECK: 'INSPECTION_RESULT_CHECK',
  INSPECTION_RESULT_APPROVE: 'INSPECTION_RESULT_APPROVE',
  SA_CHECK: 'SA_CHECK',
  SA_APPROVE: 'SA_APPROVE',
  MMMM_CHECK: 'MMMM_CHECK',
  MMMM_APPROVE: 'MMMM_APPROVE',
}

/** 認可処理区分 */
export const AuthProcessCat = {
  EDIT: '1',
  INQUIRY: '2',
}

/** S3のルートフォルダ */
export const S3Root = {
  INSP_POINT: 'inspection-points',
  SA_APP: 'app',
  SA_ATTACH: 'attach',
  SA_EVIDENCE: 'evidence',
  SA_REQUIRE_DOC: 'require-doc',
  MANUAL: 'manual',
  MMMM_REQUIRE_DOC: 'require-doc',
  MMMM_MCS: 'mcs',
  MMMM_EVALUATION: 'evaluation',
  MMMM_CMS: 'cms',
  INSP_APP: 'app',
  INSP_DIM: 'dim',
}

/** モーダルの処理モード */
export const ModalMode = {
  ADD: 'add',
  EDIT: 'edit',
  INQUIRY: 'inquiry',
  MULTIPLE: 'multiple',
  COPY: 'copy',
}

/** フォームの処理モード */
export const FormMode = {
  ADD: 'add',
  EDIT: 'edit',
  EDITONLY: 'editOnly',
  INQUIRY: 'inquiry',
  NONE: 'none',
}

/** カレンダーグループ */
export const CalendarGroup = {
  EPSON: 'EPSON',
  SUPPLIER: 'SUPPLIER',
}

/** シフトグループ */
export const ShiftGroup = {
  EPSON: 'EPSON',
  SUPPLIER: 'SUPPLIER',
}

/** 会社分類 */
export const CompanyCatCd = {
  EPSON: '1',
  SUPPLIER: '2',
}

/** 会社検査実施区分 */
export const InspCat = {
  OQC_IQC: '1',
  OQC: '2',
}

/** 測定値形式コード */
export const MeasFmtCd = {
  NUMBER: '1',
  OK_NG: '2',
}

/** OQC/IQC */
export const OqcIqcCd = {
  IQC: '1',
  OQC: '2',
}

/** 検査状態 **/
export const InspStatusCd = {
  WAITING_FOR: '0',
  IN_PROGRESS: '1',
  COMPLETE: '2',
}

/** 部品 検査タイミング **/
export const Part = {
  InspTiming: {
    EVERY_ARRIVAL: '1',
    ONCE_PER_LOT: '2',
    ONCE_A_MONTH: '3',
  },
}

/** XRF検査要否 **/
export const XrfInspNeedCd = {
  NOT_NEED: '0',
  NEED: '1',
}

/** 寸法検査の合否入力 */
export const DimJudgeCd = {
  OK: '0',
  NG: '1',
}

/** 検査結果(検査インデックス/外観検査/寸法検査) */
export const InspResultCd = {
  OK: '1',
  SA_OK: '2',
  NG: '9',
}

/** 測定結果 */
export const MeasResultCd = {
  OK: '1',
  SA_OK: '2',
  NG: '9',
}

export const ApproveStatusCd = {
  WAITING_FOR_CHECK: '1',
  WAITING_FOR_APPROVE: '2',
  APPROVED: '3',
}

export const InspClassCd = {
  APP: '1',
  DIM: '2',
}

export const SaWfCheckedCat = {
  REQUEST: '1',
  CHECK: '2',
  APPROVE: '3',
}

export const SaProductionCatCd = {
  INITIAL: '1',
  MP: '2',
}

export const PartJudge = {
  MATCH: '1',
  DIFFERENT_NAMES: '2',
  EC_UP: '3',
  EC_DOWN: '4',
  NOT_IN_TOPICS_II: '5',
}

export const SaApprovalStatusCd = {
  TEMP_SAVE: '0',
  SUPPLIER_APPLYING: '1',
  SUPPLIER_APPROVED: '2',
  EPSON_APPLYING: '3',
  APPROVED: '4',
  DENY: '9',
  INVALID: '10',
}

export const InspQtyStdCd = {
  TOTAL_QTY_OF_LOT: '1',
  QTY_OF_ACCEPTANCE_LOT: '2',
  FIXED_QTY_PER_LOT: '3',
  CUM_ACCEPTANCE_QTY: '4',
}

export const InspCharacCatCd = {
  GEOMETRIC_TOLERANCE: '1',
  DIMENSIONAL_TOLERANCE: '2',
  OK_NG: '3',
}

export const SystemParameterKey = {
  SKIP_SAME_LOT_DIM: 'SKIP_SAME_LOT_DIM',
  FORMAT_LOT_NO: 'FORMAT_LOT_NO',
  FORMAT_LOT_STARTUP: 'FORMAT_LOT_STARTUP',
  MATL_SPEC_REQ: 'MATL_SPEC_REQ',
  COMPANY_LOC_REQ: 'COMPANY_LOC_REQ',
  COMPANY_CAPA_REQ: 'COMPANY_CAPA_REQ',
  CHAR_POINT_LIMIT: 'CHAR_POINT_LIMIT',
  CHAR_TECNO_LIMIT: 'CHAR_TECNO_LIMIT',
  CHAR_TECNO_REQ: 'CHAR_TECNO_REQ',
  CHAR_MEAS_INST_REQ: 'CHAR_MEAS_INST_REQ',
  INSP_CAV_LIMIT: 'INSP_CAV_LIMIT',
  ALPHA_URL: 'ALPHA_URL',
  CAN_EDIT_SA_DIM: 'CAN_EDIT_SA_DIM',
  PT_CD_LEN: 'PT_CD_LEN',
  IS_MANAGED_PART_BY_MOLD: 'IS_MANAGED_PART_BY_MOLD',
}

export const ModelPlantJudgeCd = {
  OK: '0',
  NG: '1',
}

export const SA_EXPIRATION_DATE = 30

export const RESPONSE_UNTIL = 7

export const InspGradeCd = {
  A: 'A',
  B: 'B',
}

export const MmmmApprovalStatusCd = {
  TEMP_SAVE: '0',
  SUPPLIER_APPLYING: '1',
  SUPPLIER_APPROVED: '2',
  EPSON_APPLYING: '3',
  APPROVED: '4',
  DENY: '9',
}

export const MmmmWfCheckedCat = {
  REQUEST: '1',
  CHECK: '2',
  APPROVE: '3',
}

export const MmmmEvaluationResultCd = {
  OK: '1',
  NA: '2',
  NG: '9',
}

export const MmmmDispositionCd = {
  ACCEPT: '1',
  CONDITIONALLY_ACCEPT: '2',
  REJECT: '9',
}

export const MmmmProductTakeOut = {
  ROBOT: '1',
  MANUAL: '2',
  DROP: '3',
}

export const MmmmInjectionMCType = {
  HYDRAULIC: '1',
  ELECTRIC: '2',
}

export const MmmmSecondaryCategory = {
  PRINTING: '1',
  PAINTING: '2',
  CAULKING: '3',
  SUB_ASSEMBLY: '4',
  OTHERS: '9',
}

export const MmmmPaintingProcess = {
  ROBOT: '1',
  MANUAL: '2',
  OTHERS: '9',
}

export const MmmmInkProcess = {
  TAMPO_PAD: '1',
  SILKSCREEN: '2',
  HOT_STAMP: '3',
  OTHERS: '9',
}

export const InspectionTimingDtl = {
  SOURCE: '3',
  OUTGOING: '4',
  ADVANCE_SAMPLE: '5',
  INCOMING: '6',
}

export const CmsEffJudgeCd = {
  OK: '0',
  NG: '1',
}

export const CmsApprovalStatusCd = {
  TEMP_SAVE: '0',
  SUPPLIER_APPLYING: '1',
  SUPPLIER_APPROVED: '2',
  EPSON_APPLYING: '3',
  APPROVED: '4',
  INVALID: '10',
}

export const SaFileCatCd = {
  COMMON_SA: '1',
  CMS_SA: '2',
}

export const SaLinkCatCd = {
  COMMON_SA: '1',
  CMS_SA: '2',
}

export const InspectionIndex4M = {
  NOT_STARTED_YET: 'NOT STARTED YET',
}

export const InspInfoRange = {
  ONCE_MONTH: "1",
  THREE_MONTH: "2",
  SIX_MONTH: "3",
  TWELVE_MONTH: "4",
}

export const XrfPostProcessingCd = {
  SCRAP: "1",
  RETURN: "2",
}
